const cabinetBulkEditTraitVisibleBehavior = async (source, content, parentContentPath, transientContext
// nativeFunctions,
// sourceEvaluator,
) => {
  const _transientContext$sel = transientContext.selection,
    selection = _transientContext$sel === void 0 ? {} : _transientContext$sel;
  const formTypeIdentifiers = Object.keys(selection);
  return formTypeIdentifiers.length === 1 && formTypeIdentifiers[0] === source.value;
};
module.exports = {
  evaluate: cabinetBulkEditTraitVisibleBehavior
};